import React, { useState } from 'react'
import './UF.css'

const PE = () => {
  const [service] = useState([
    { id: 1, uf: 'PE', city: 'Recife', name: 'Clínica-Escola de Psicologia da UNINASSAU', address: 'Rua Ana Angélica, 45, bairro do Derby', phone: '(81) 2121-5922', type: 'Clínica escola', info: '-' },
    { id: 2, uf: 'PE', city: 'Recife', name: 'Serviço de Psicologia Aplicada da UFPE', address: 'Avenida Acadêmico Hélio Ramos, s/n, Várzea', phone: '(81) 2126-8731', type: 'Clínica escola', info: 'spa.psi@ufpe.br | secretaria.spa@ufpe.br' },
    //    { id: 0, uf: '', city: '', name: '', address: '', phone: '', type: '', info: '' },
  ]);

  const [filter, setFilter] = useState('');

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const filteredService = service.filter((item) =>
    item.city.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div id="Board">
      <p id='showResult'>
        Aqui estão os serviços encontrados para o estado selecionado.
        <br />
        Se preferir, use o campo abaixo para filtrar os resultados por cidade.
        <br /><br />
        <input type="text" value={filter} onChange={handleFilterChange} placeholder="Digite o nome da cidade" />
      </p>
      <h3>Pernambuco</h3>
      <p>
        <ul>
          {filteredService.map((item) => (
            <li key={item.id}>
              <strong>{item.name}</strong><br />
              <strong>UF: </strong>{item.uf}<br />
              <strong>Cidade: </strong>{item.city}<br />
              <strong>Endereço: </strong>{item.address}<br />
              <strong>Telefone: </strong>{item.phone}<br />
              <strong>Tipo: </strong>{item.type}<br />
              <strong>Mais Informações: </strong>{item.info}<br />
              <hr />
            </li>
          ))}
        </ul>
      </p>
    </div>
  )
}

export default PE
